export enum PayoutAccountTypeEnum {
    None = 0,
    Bank = 1,
    EWallet = 2
}
